import React, {PropTypes} from 'react';
import axios from '../../../../constants/axios';
// import { IndexLink, Link } from 'react-router';
// import { Button, Table } from 'react-bootstrap';
import moment from 'moment';
import inWord from 'taka-amount-to-word-js';
// import debounce from 'lodash/debounce';
// import alert from 'alertify.js';
// import classname from 'classnames';

import './SaleInvoiceDetailOfficialLayout.less';

let logo = require('./mar71logo-red.png');

class SaleInvoiceDetailOfficialLayout extends React.Component {

   constructor(props) {
      super(props);
      this.state = {
         invoiceDetails: {},
         invoiceItems: [],
         loading: false,
         challanMode: false,
         time: moment().format('DD.MM.YYYY hh:mm A'),
      };
   }


   componentDidMount() {
      this.interval = setInterval(() => {
         this.setState({
            time: moment().format('DD.MM.YYYY hh:mm A'),
         });
      }, 5000);
      this.loadInvoiceDetails();
   }

   componentWillUnmount() {
      clearInterval(this.interval);
   }

   loadInvoiceDetails = () => {
      const {invoiceId} = this.props.params;
      this.setState({
         loading: true,
      });
      return Promise.all([axios.get(`inventorySales/getInvoiceDetailsById/${invoiceId}`), axios.get(`inventorySales/getInventoryItemsByInvoiceId/${invoiceId}`)])
         .then(([invoiceDetailsRes, itemsDetailsRes]) => {
            this.setState({
               invoiceDetails: invoiceDetailsRes.data,
               invoiceItems: itemsDetailsRes.data,
               loading: false,
            });
         });
   };

   inputChangeHandler = (e) => {
      this.setState({
         [e.target.name]: !this.state[e.target.name]
      });
   };

   printPage = () => {
      window.print();
   };

   render() {
      const {invoiceDetails, loading, time, invoiceItems, challanMode} = this.state;
      if (loading === true) {
         return <div>Loading.</div>;
      }
      return (
         <div className="SaleInvoiceDetailOfficialLayout">
            <div className="controls">
               <label htmlFor="challanMode">Challan</label>
               <input type="checkbox" name="challanMode" id="challanMode" checked={this.state.challanMode}
                      onChange={(e) => this.inputChangeHandler(e)}/>
            </div>
            <div className="invoice_header">
               <img src={logo} width={250} height={70}/>
               <div className="company_info">
                  <h3>mart71.com</h3>
                  <h6>Mobile: 01910717171, 01519717171</h6>
                  <h6>Email: support@mart71.com</h6>
               </div>
            </div>
            <h4 className="invoice_bill">{challanMode ? "Challan" : "Invoice / Bill"}</h4>
            <hr/>
            <div className="bill_info">
               <div className="customer_info">
                  <table>
                     <tr>
                        <td>Customer Name:</td>
                        <td>{invoiceDetails.contact_name}</td>
                     </tr>
                     <tr>
                        <td>Contact Number:</td>
                        <td>{invoiceDetails.contact_mobile}</td>
                     </tr>
                     <tr>
                        <td>Address:</td>
                        <td>{invoiceDetails.contact_address}</td>
                     </tr>
                  </table>
               </div>
               <div>
                  <table className="invoice_details_table">
                     <tr>
                        <td>{challanMode ? "Challan No" : "Invoice No"}</td>
                        <td>{invoiceDetails.id}</td>
                     </tr>
                     <tr>
                        <td>{challanMode ? "Challan Date" : "Invoice Date"}</td>
                        <td>{invoiceDetails.created_at}</td>
                     </tr>
                     <tr>
                        <td>Delivery Date</td>
                        <td>{invoiceDetails.delivery_time}</td>
                     </tr>
                  </table>
               </div>
            </div>
            <div className="items">
               <table className="items_table">
                  <thead>
                  <tr>
                     <th>SL</th>
                     <th>Item Name</th>
                     <th>Qty</th>
                     {!challanMode && <th>Rate</th>}
                     {!challanMode && <th>Disc</th>}
                     {!challanMode && <th>Taka</th>}
                  </tr>
                  </thead>
                  <tbody>
                  {invoiceItems.items && invoiceItems.items.map((item, index) => (
                     <tr key={item.id}>
                        <td>{index + 1}</td>
                        <td className="item_name">{item.name}</td>
                        <td className="item_unit">{item.unit}</td>
                        {!challanMode && <td className="item_price">{item.price}</td>}
                        {!challanMode && <td className="item_discount">{item.unit_discount}</td>}
                        {!challanMode &&
                        <td className="item_total">{(item.unit * (item.price - item.unit_discount)).toFixed(2)}</td>}
                     </tr>
                  ))}
                  <tr className="all_total">
                     <td colSpan={3}>Weight: {invoiceItems.totalWeight} KG</td>
                     {!challanMode && <td>Total</td>}
                     {!challanMode && <td>{invoiceItems.unitDiscountTotal}</td>}
                     {!challanMode && <td className="item_total">{invoiceDetails.total_amount}</td>}
                  </tr>
                  </tbody>
               </table>
            </div>
            {!challanMode && <div className="invoice_footer">
               <div>
                  <table>
                     <tr>
                        <td>In Words (Taka):</td>
                        <td className="in_word"> {inWord(parseFloat(invoiceDetails.total_amount))}</td>
                     </tr>
                     <tr>
                        <td>Payment Method:</td>
                        <td/>
                     </tr>
                     <tr>
                        <td>Notes:</td>
                        <td/>
                     </tr>
                  </table>
               </div>
               <div>
                  <table>
                     <tr>
                        <td>Total Taka:</td>
                        <td>{invoiceDetails.total_amount}</td>
                     </tr>
                     <tr>
                        <td>Delivery Charge:</td>
                        <td>0.00</td>
                     </tr>
                     <tr>
                        <td>Net Payable:</td>
                        <td>{invoiceDetails.total_amount}</td>
                     </tr>
                  </table>
               </div>
            </div>}
            <hr/>
            <div className="signature_area">
               <div>
                  Authorized Signature
               </div>
               <div>
                  Please Check items before signature.
               </div>
               <div>
                  Customer Signature
               </div>
            </div>
            <div className="developer_info">
               <h6>App Dev: fb.com/fazalrasel, print time:{time}</h6>
            </div>
         </div>
      );
   }
}

SaleInvoiceDetailOfficialLayout.propTypes = {
   params: PropTypes.object,
   children: PropTypes.object,
   location: PropTypes.object,
};


export default SaleInvoiceDetailOfficialLayout;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/Sale/SaleInvoiceDetailOfficialLayout/SaleInvoiceDetailOfficialLayout.js
 **/